import React from 'react';

export default class FloatingButton extends React.Component {

    static Theme = {
        Filled: 'filled',
        BorderOnly: 'border-only'
    }

    static defaultProps = {
        theme: FloatingButton.Theme.Filled
    }

    render() {
        const classNames = [
            'floating-button',
            'floating-button-theme-' + this.props.theme
        ]

        return (
            <div className={classNames.join(' ')}>
                {this.props.children}
            </div>
        )
    }
}